export class NetworkError extends Error {
  statusCode: number;
  originalError?: object;
  constructor(message: string, statusCode: number, originalError?: object) {
    super(message);
    this.statusCode = statusCode;
    this.originalError = originalError;
  }
}
